import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";

// Imágenes
import logo from "../assets/img/esp.png";
import bgImage from "../assets/img/silueta.png";
import blob from "../assets/img/blob-haikei.png";
import text from "../assets/img/text1.png";

export default function NuestraEspecialidadSection({
  background = blob,
  mail = "direccion@kuelly.com.mx",
}) {
  const KU_GREEN = "#2f5d35";

  return (
    <section
      className="position-relative overflow-hidden"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "white",
      }}
    >
      {/* Overlay para contraste del texto */}
      <div className="spec-overlay" aria-hidden="true" />

      <style>{`
        :root { --ku-green: ${KU_GREEN}; }

        .spec-overlay{
          position:absolute; inset:0; z-index:1;
          background: linear-gradient(180deg, rgba(0,0,0,.35) 0%, rgba(0,0,0,.55) 60%, rgba(0,0,0,.55) 100%);
        }

        .spec-wrap { min-height: 72vh; position: relative; z-index: 2; }
        @media (max-width: 991.98px){ .spec-wrap{ min-height: auto; } }

        /* Col izquierda (ilustración) */
        .col-img-wrap{
          position: relative; width: 100%; height: 100%;
          display:flex; align-items:flex-end; justify-content:center;
          padding: clamp(8px, 3vw, 24px);
        }
        .col-img{
          width: min(540px, 80vw);
          height: auto;
          object-fit: contain;
          filter: drop-shadow(0 10px 24px rgba(0,0,0,.25));
        }
        @media (max-width: 991.98px){
          .col-img{ width: min(420px, 90vw); }
        }
        @media (max-width: 575.98px){
          .col-img{ width: min(360px, 92vw); }
        }

        /* Col derecha (contenido) */
        .spec-right{ color:#fff; }

        .spec-logo{
          width: clamp(180px, 38vw, 400px);
          height: auto;
        }

        .spec-title{
          font-weight: 900; line-height:1.08; letter-spacing:.02em;
          font-size: clamp(22px, 6vw, 48px);
          margin: 0;
        }

        .spec-sub{
          margin-top: 10px; font-weight:700; line-height:1.3;
          font-size: clamp(14px, 2.4vw, 18px); color:#f0f0f0;
          max-width: 900px;
        }

        .spec-bullet{
          color: var(--ku-green); font-weight:900; margin-right:.5rem; font-size: 18px;
        }
        .spec-item{ margin: 8px 0; font-size: clamp(14px, 2.3vw, 18px); }

        /* Imagen de texto/lista */
        .textimg{
          width: min(860px, 92%);
          height: auto;
        }
        @media (max-width: 575.98px){
          .textimg{ width: 100%; }
        }

        /* Espaciados reusables */
        .spec-pad { padding: clamp(16px, 4vw, 40px); }
      `}</style>

      <Container fluid className="p-0">
        <Row className="g-0 spec-wrap">
          {/* Izquierda: ilustración; en móvil va abajo (order-2) */}
          <Col xs={12} lg={5} className="p-0 order-2 order-lg-1">
            <div className="col-img-wrap">
              <img src={bgImage} alt="Silueta Kuelly" className="col-img" />
            </div>
          </Col>

          {/* Derecha: contenido principal; en móvil va arriba (order-1) */}
          <Col xs={12} lg={7} className="spec-right order-1 order-lg-2 spec-pad">
            <div className="d-flex justify-content-center justify-content-lg-start">
              <Image src={logo} alt="Kuelly - Nuestra Especialidad" className="spec-logo" />
            </div>

            <div className="mt-3 mt-md-4">
              <h2 className="spec-title text-center text-lg-start">
                Desarrollamos Proyectos Llave en Mano
              </h2>
              <p className="spec-sub text-center text-lg-start">
                Que incluye las siguientes actividades:
              </p>
            </div>

            {/* Lista visual (imagen) */}
            <div className="d-flex justify-content-center justify-content-lg-start mt-3">
              <Image src={text} alt="Actividades incluidas" className="textimg" />
            </div>

            {/* Correo */}
            <div className="mt-3 fw-bold text-center text-lg-start" style={{ color: "#e6e6e6" }}>
              {mail}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
